import React from 'react';

export default class ProgressBar extends React.Component {
  constructor(props) {
    super(props);

    this.minimumValue = this.props.minimumValue || 0;
    this.maximumValue = this.props.maximumValue || 100;
  }

  render() {
    return (
      <div className="panel panel--md panel--solo">
        <h1 className="panel__title"></h1>

        <div className="progress-bar">
          <progress
            className="progress-bar__bar"
            max={this.maximumValue}
            min={this.minimumValue}
            value={this.props.value}
            aria-label="progress-value"
          ></progress>

          <output className="progress-bar__value" id="progress-value"></output>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/SessionEnd/ProgressBar.js